// extracted by mini-css-extract-plugin
module.exports = {"buttonSelect":"button_select_buttonSelect__HJeMW","or":"button_select_or__2s9OB","wrapper":"button_select_wrapper__1LiMi","line":"button_select_line__21M64"};